import { render } from "./Renewal.vue?vue&type=template&id=3740be05"
import script from "./Renewal.vue?vue&type=script&lang=js"
export * from "./Renewal.vue?vue&type=script&lang=js"

import "./Renewal.vue?vue&type=style&index=0&id=3740be05&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__